module.exports = __webpack_public_path__ + "assets/fonts/iconfont.25cf451e.woff2";